<template>
  <Modal v-bind="$attrs" @close="handleClose" :width="500" :title="$t('selectLanguage.title')">
    <div class="form-modal">
      <div class="tips">{{ $t("selectLanguage.hint") }}</div>
      <div class="select-item">
        <div class="select-title">{{ $t("selectLanguage.language") }}</div>
        <Select
          :icon="iconlanguage"
          :selectedValue="selectedValueLanguage"
          :placeholders="$t('selectLanguage.titleLanguage')"
          :selectData="languageList"
          @change="changeLanguage"
        />
      </div>
      <!-- <input type="text" ="" name="" id=""> -->
      <div class="select-item">
        <div class="select-title">{{ $t("selectLanguage.currency") }}</div>
        <Select
          :placeholders="$t('selectLanguage.titleCurrency')"
          :selectedValue="selectedValueLanguage"
          :icon="require('@/assets/icon_currency.png')"
          :selectData="currencyList"
          @change="changeCurrency"
        />
      </div>
      <Button @click="saveChange">{{ $t("selectLanguage.button") }}</Button>
    </div>
  </Modal>
</template>

<script>
import Modal from "../Modal/index.desktop";
import Button from "../Button/button.desktop";
import Select from "../Select/index.desktop";
export default {
  name: "ModalTips",
  data() {
    return {
      iconlanguage: null,
      selectedValueLanguage: null,
      selectedValueCurrency: null,
      currencyList: [
        { name: "￥JPY", value: "ja-jp" },
        { name: "$USD", value: "en-us" },
      ],
      languageList: [
        { name: "やまと", value: "ja-jp", icon: require("@/assets/img_Japan.png") },
        { name: "English", value: "en-us", icon: require("@/assets/img_usa.png") },
      ],
    };
  },
  created() {
    this.selectedValueLanguage =
      window.localStorage.getItem("language") || this.languageList[0].value;
    this.$i18n.locale = this.selectedValueLanguage;
    const idx = this.languageList.findIndex((ele) => ele.value === this.selectedValueLanguage);
    this.iconlanguage = this.languageList[idx].icon;
  },
  components: { Modal, Button, Select },
  methods: {
    changeCurrency(_, value) {
      this.selectedValueCurrency = value;
    },
    handleClose() {
      this.$emit("close");
    },
    changeLanguage(_, value, data) {
      this.selectedValueLanguage = value;
      this.iconlanguage = data.icon;
    },
    saveChange() {
      this.$i18n.locale = this.selectedValueLanguage;
      window.localStorage.setItem("language", this.selectedValueLanguage);
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.tips {
  font-size: 12px;
  line-height: 17px;
  color: #979797;
}

.select-item {
  margin-top: 33px;
  &:last-of-type {
    margin-bottom: 76px;
  }
  .select-title {
    margin-bottom: 18px;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #ffffff;
  }
}

.form-modal {
  padding: 18px 32px 36px;
}
</style>
